import { ref } from "vue";

// TODO: proper types
export const useResultsSorting = <T>(
	customGetters: Record<string, (result: T) => string | number | boolean>
) => {
	const sortingOrder = ref<null | {
		key: string;
		ascending: boolean;
	}>(null);

	const setSortingOrder = (key: string, ascending: boolean | null) => {
		sortingOrder.value = ascending === null ? null : { key, ascending };
	};

	const isAscendingColumn = (key: string) => {
		if (sortingOrder.value === null) return null;
		return sortingOrder.value.key === key
			? sortingOrder.value.ascending
			: null;
	};

	const applySorting = (results: T[]) => {
		if (!sortingOrder.value) {
			return results;
		}
		const resultsCopy = results.slice();
		const key = sortingOrder.value.key;
		const getter =
			customGetters[key] || ((result: T) => result[key as keyof T]);
		const ascending = sortingOrder.value.ascending;
		const comparator = ascending
			? (a: T, b: T) => (getter(a) > getter(b) ? -1 : 1)
			: (a: T, b: T) => (getter(a) > getter(b) ? 1 : -1);
		resultsCopy.sort(comparator);
		return resultsCopy;
	};

	return {
		sortingOrder,
		setSortingOrder,
		isAscendingColumn,
		applySorting,
	};
};
